import { Box, TextButton, TooltipCommonProps } from '@wix/design-system';
import { ArticleSmall } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';

import { IAIArticleAnswerItem } from '../../../common/messageCreators';
import { useOpenArticleFromChatbot } from '../../hooks/useOpenArticleFromChatbot';
import { AIArticleAnswerDataHooks } from './AIArticleAnswer.dataHooks';

const articleTitleTooltipProps: TooltipCommonProps = { size: 'small' };

export const AIArticleAnswerItem: FC<IAIArticleAnswerItem> = ({ articleId, title }) => {
  const openArticleFromChatbot = useOpenArticleFromChatbot();

  const openArticle = useCallback(
    () => openArticleFromChatbot(articleId),
    [openArticleFromChatbot, articleId],
  );

  return (
    <Box verticalAlign="middle" gap={1} overflow="hidden">
      <Box color="D10">
        <ArticleSmall />
      </Box>
      <Box overflow="hidden">
        <TextButton
          size="tiny"
          skin="dark"
          underline="always"
          ellipsis
          tooltipProps={articleTitleTooltipProps}
          onClick={openArticle}
          dataHook={AIArticleAnswerDataHooks.articleTitle()}
        >
          {title}
        </TextButton>
      </Box>
    </Box>
  );
};
